import { render } from "./B2bTableBorradores.vue?vue&type=template&id=70def9b9&scoped=true&lang=pug"
import script from "./B2bTableBorradores.vue?vue&type=script&lang=js"
export * from "./B2bTableBorradores.vue?vue&type=script&lang=js"

import "./B2bTableBorradores.vue?vue&type=style&index=0&id=70def9b9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70def9b9"]])

export default __exports__